import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ToastProvider from './components/ui/ToastProvider'
import AppRoutes from './routes/AppRoutes'
import ExitIntentPopup from './components/common/ExitIntentPopup'
import { initGA4, initPostHog, trackPageView } from './utils/analytics'

const GA4_ID = (import.meta as any).env?.VITE_GA4_MEASUREMENT_ID as string | undefined;
const POSTHOG_KEY = (import.meta as any).env?.VITE_POSTHOG_KEY as string | undefined;

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const saved = localStorage.getItem('vawena-theme') || 'dark';
    const root = document.documentElement;
    if (saved === 'light') {
      root.classList.remove('dark');
      root.classList.add('light');
      document.body.style.backgroundColor = '#f0f4ff';
    } else {
      root.classList.add('dark');
      root.classList.remove('light');
      document.body.style.backgroundColor = '#020D30';
    }

    if (GA4_ID) initGA4(GA4_ID);
    if (POSTHOG_KEY) initPostHog(POSTHOG_KEY);
  }, []);

  return (
    <div className="min-h-screen w-full max-w-[100vw] overflow-x-clip bg-[#f0f4ff] dark:bg-[#020D30]">
      <PageTracker />
      <ToastProvider />
      <AppRoutes />
      <ExitIntentPopup />
    </div>
  );
}

export default App